import { makeStyles } from '@material-ui/core';

const styles = (theme) => ({
  modalHeader: {
    marginBottom: theme.spacing(6),
    fontSize: 40,
    fontWeight: 300
  },
  modalContent: {
    lineHeight: 1.2,
    display: 'block'
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  },
  yesBtn: {
    padding: theme.spacing(1, 2),
    width: 144,
    height: 36
  },
  noBtn: {
    padding: theme.spacing(1, 2),
    width: 98,
    height: 36
  }
});

export default makeStyles(styles);
